/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { useLocation, NavLink, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavList from "examples/Sidenav/SidenavList";
import SidenavItem from "examples/Sidenav/SidenavItem";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import Menu from "@mui/material/Menu";
import NotificationItem from "examples/Items/NotificationItem";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 PRO React context
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import { useSelector } from "react-redux";
import ApiCalls from "services/flick_erp_api_call";
import { Box, IconButton } from "@mui/material";
import { logout } from "helpers/navigation";
import MDAvatar from "components/MDAvatar";
import Logo from "../../assets/ge_logo.png"

function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openNestedCollapse, setOpenNestedCollapse] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const [openUserMenu, setOpenUserMenu] = useState(null);
	const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;
  const location = useLocation();
	const navigate = useNavigate();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const items = pathname.split("/").slice(1);
  const itemParentName = items[1];
  const itemName = items[items.length - 1];
  const [employee, setEmployee] = useState({});

  const user = JSON.parse(localStorage.getItem("user"));
  // const u = useSelector((state)=>state.user)


  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    setOpenCollapse(collapseName);
    setOpenNestedCollapse(itemParentName);
    getEmployee();
  }, []);
  async function getEmployee() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user != undefined || user != null) {
      var res = await ApiCalls.getEmployee(user?.employee_id);

      if (res.success && res.code == 200) {
        setEmployee(res.data);
      } else {
      }
    }
  }

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : transparentSidenav
      );
      setWhiteSidenav(
        dispatch,
        window.innerWidth < 1200 ? false : whiteSidenav
      );
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);

  // Render all the nested collapse items from the routes.js
  const renderNestedCollapse = (collapse) => {
    const template = collapse.map(({ name, icon, route, key, href }) =>
      href ? (
        <Link
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavItem name={name} nested />
        </Link>
      ) : (
        <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
          <SidenavItem name={name} active={route === pathname} nested />
        </NavLink>
      )
    );

    return template;
  };
  // Render the all the collpases from the routes.js
  const renderCollapse = (collapses) =>
    collapses.map(
      ({
        name,
        icon,
        collapse,
        route,
        href,
        key,
        requireRole,
        modulePermissions,
        permissionKey,
      }) => {
        let returnValue;
        if (collapse) {
          returnValue = (
            <SidenavItem
              key={key}
              color={color}
              name={name}
              active={key === itemParentName ? "isParent" : false}
              open={openNestedCollapse === key}
              onClick={({ currentTarget }) =>
                openNestedCollapse === key &&
                currentTarget.classList.contains("MuiListItem-root")
                  ? setOpenNestedCollapse(false)
                  : setOpenNestedCollapse(key)
              }
            >
              {renderNestedCollapse(collapse)}
            </SidenavItem>
          );
          return <SidenavList key={key}>{returnValue}</SidenavList>;
        } else {
          if (
            requireRole &&
            user != undefined &&
            user?.permissions_all != undefined
          ) {
            if (
              user?.permissions_all[permissionKey]?.includes(
                modulePermissions?.list_permission
              ) ||
              user?.permissions_all[permissionKey]?.includes(
                modulePermissions?.own_list_permission
              )
            ) {
              returnValue = href ? (
                <Link
                  href={href}
                  key={key}
                  target="_blank"
                  rel="noreferrer"
                  sx={{ textDecoration: "none" }}
                >
                  <SidenavItem
                    color={color}
                    icon={icon}
                    name={name}
                    active={key === itemName}
                  />
                </Link>
              ) : (
                <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
                  <SidenavItem
                    color={color}
                    name={name}
                    icon={icon}
                    active={key === itemName}
                  />
                </NavLink>
              );
              return <SidenavList key={key}>{returnValue}</SidenavList>;
            }
          } else {
            returnValue = href ? (
              <Link
                href={href}
                key={key}
                target="_blank"
                rel="noreferrer"
                sx={{ textDecoration: "none" }}
              >
                <SidenavItem
                  color={color}
                  icon={icon}
                  name={name}
                  active={key === itemName}
                />
              </Link>
            ) : key == "logout" ? (
              <NavLink
                onClick={() => {
                  localStorage.clear();
                  // logout()
                }}
                to={route}
                key={key}
                sx={{ textDecoration: "none" }}
              >
                <SidenavItem
                  color={color}
                  name={name}
                  icon={icon}
                  active={key === itemName}
                />
              </NavLink>
            ) : (
              <NavLink to={route} key={key} sx={{ textDecoration: "none" }}>
                <SidenavItem
                  color={color}
                  name={name}
                  icon={icon}
                  active={key === itemName}
                />
              </NavLink>
            );
            return <SidenavList key={key}>{returnValue}</SidenavList>;
          }
        }
      }
    );

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  // const renderRoutes = routes.map(
  //   ({ type, name, icon, title, collapse, noCollapse, key, href, route }) => {
  //     let returnValue;

  //     if (type === "collapse") {
  //       if (href) {
  //         returnValue = (
  //           <Link
  //             href={href}
  //             key={key}
  //             target="_blank"
  //             rel="noreferrer"
  //             sx={{ textDecoration: "none" }}
  //           >
  //             <SidenavCollapse
  //               name={name}
  //               icon={icon}
  //               active={key === collapseName}
  //               noCollapse={noCollapse}
  //             />
  //           </Link>
  //         );
  //       } else if (noCollapse && route) {
  //         returnValue = (
  //           <NavLink to={route} key={key}>
  //             <SidenavCollapse
  //               name={name}
  //               icon={icon}
  //               noCollapse={noCollapse}
  //               active={key === collapseName}
  //             >
  //               {collapse ? renderCollapse(collapse) : null}
  //             </SidenavCollapse>
  //           </NavLink>
  //         );
  //       } else {



       
  //         var isRenderMenu =    collapse.some((e) => e.requireRole == false)
  //           ? true
  //           : collapse.some(
  //             (e) =>
  //               user != undefined &&
  //               user?.permissions_all[e.permissionKey] != undefined &&
  //               (user?.permissions_all[e.permissionKey]?.includes(
  //                 e?.modulePermissions?.list_permission
  //               ) ||
  //                 user?.permissions_all[e.permissionKey]?.includes(
  //                   e?.modulePermissions?.own_list_permission
  //                 ))
  //           );

  //         if (isRenderMenu) {
  //           returnValue = (
  //             <SidenavCollapse
  //               key={key}
  //               name={
  //                 name == "Current User"
  //                   ? `${employee?.user?.firstname ?? ""} ${
  //                       employee?.user?.lastname ?? ""
  //                     }`
  //                   : name
  //               }
  //               icon={icon}
  //               profileImage={
  //                 name == "Current User" ? employee?.img : undefined
  //               }
  //               active={key === collapseName}
  //               open={openCollapse === key}
  //               onClick={() => {
  //                 openCollapse === key
  //                   ? setOpenCollapse(false)
  //                   : setOpenCollapse(key);
  //               }}
  //             >
  //               {collapse ? renderCollapse(collapse) : null}
  //             </SidenavCollapse>
  //           );
  //         }
  //       }
  //     } else if (type === "title") {
  //       returnValue = (
  //         <MDTypography
  //           key={key}
  //           color={textColor}
  //           display="block"
  //           variant="caption"
  //           fontWeight="bold"
  //           textTransform="uppercase"
  //           pl={3}
  //           mt={2}
  //           mb={1}
  //           ml={1}
  //         >
  //           {title}
  //         </MDTypography>
  //       );
  //     } else if (type === "divider") {
  //       returnValue = (
  //         <Divider
  //           key={key}
  //           light={
  //             (!darkMode && !whiteSidenav && !transparentSidenav) ||
  //             (darkMode && !transparentSidenav && whiteSidenav)
  //           }
  //         />
  //       );
  //     }

  //     return returnValue;
  //   }
  // );

	const handleOpenProfile = () => {
		setOpenUserMenu(null);
		navigate("/pages/profile/profile-overview", {
			state: {
				userid: employee?.user?.emp_id,
			},
		})
	}

	const handleLogout = () => {
		setOpenUserMenu(null)
		localStorage.removeItem("user");
		navigate("/authentication/sign-in/illustration");
	}

	const handleCloseUserMenu = () => {
		setOpenUserMenu(null);
	}

	const handleOpenUserMenu = (event) => setOpenUserMenu(event.currentTarget);

	const renderUserMenuItems = () => {
		return (
			<Menu
				anchorEl={openUserMenu}
				open={Boolean(openUserMenu)}
				onClose={handleCloseUserMenu}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
			>
				<NotificationItem
					onClick={handleOpenProfile}
					icon={<Icon>account_circle</Icon>}
					title="View Profile"
				/>
				<NotificationItem
					onClick={handleLogout}
					icon={<Icon>logout</Icon>}
					title="Logout"
				/>
			</Menu>
		);
	}


  const renderRoutes = routes.filter((routeItem) => routeItem.key !== "currentUser").map(
    ({ type, name, icon, title, collapse, noCollapse, key, href, route, displayOnly, modulePermissions, permissionKey }) => {
      let returnValue;

      if (type === "collapse") {
        if (displayOnly) {
          returnValue = (
            <SidenavCollapse
              key={key}
              name={name}
              icon={icon}
              noCollapse={true} 
              active={false} 
            />
          );
        } else if (href) {
          returnValue = (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
              />
            </Link>
          );
        } else if (noCollapse && route) {
          returnValue = (
            <NavLink to={route} key={key}>
              <SidenavCollapse
                name={name}
                icon={icon}
                noCollapse={noCollapse}
                active={key === collapseName}
              >
                {collapse ? renderCollapse(collapse) : null}
              </SidenavCollapse>
            </NavLink>
          );
        } else {
          const isRenderMenu = collapse.some((e) => e.requireRole === false)
            ? true
            : collapse.some(
                (e) =>
                  user &&
                  user?.permissions_all[e.permissionKey] &&
                  (user?.permissions_all[e.permissionKey]?.includes(
                    e?.modulePermissions?.list_permission
                  ) ||
                    user?.permissions_all[e.permissionKey]?.includes(
                      e?.modulePermissions?.own_list_permission
                    ))
              );
  
          if (isRenderMenu) {
            returnValue = (
              <SidenavCollapse
                key={key}
                name={
                  name === "Current User"
                    ? `${employee?.user?.firstname ?? ""} ${
                        employee?.user?.lastname ?? ""
                      }`
                    : name
                }
                icon={icon}
                profileImage={
                  name === "Current User" ? employee?.img : undefined
                }
                active={key === collapseName}
                open={openCollapse === key}
                onClick={() => {
                  openCollapse === key
                    ? setOpenCollapse(false)
                    : setOpenCollapse(key);
                }}
              >
                {collapse ? renderCollapse(collapse) : null}
              </SidenavCollapse>
            );
          }
        }
      } else if (type === "title") {
        returnValue = (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      } else if (type === "divider") {
        returnValue = (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      }
      else if(type === 'header')
      {
          const permissionScope = permissionKey || key;
          const isAlwaysVisibleHeader = key === "dashboards";
          const canRenderHeader =
            isAlwaysVisibleHeader || (
              user &&
              user?.permissions_all?.[permissionScope] &&
              Object.values(modulePermissions || {}).some(
                (permissionGroup) =>
                  Object.values(permissionGroup || {}).some(
                    (permissionValue) =>
                      permissionValue &&
                      user?.permissions_all?.[permissionScope]?.includes(permissionValue)
                  )
              )
            );

          if (displayOnly && route && canRenderHeader) {
            // Render header only when the user can access at least one recruitment section.
            returnValue = (
              <NavLink to={route} key={key}>
              <SidenavCollapse
                name={name}
                icon={icon}
                noCollapse={true}
                active={key === collapseName}
              >  
              </SidenavCollapse>
            </NavLink>
            );
          }
        
      }
  
      return returnValue;
    }
  );

	const normalizeImage = (image) => {
    if (!image) return "";
    return image.startsWith("http") ? image : `${base_url}${image}`;
  };

  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pt={3} pb={2} px={3}>
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox component={NavLink} to="/" display="flex" alignItems="center" gap={3}>
          <MDBox
            sx={({ palette }) => ({
              width: 50,
              height: 50,
              borderRadius: "100%",
              display: "grid",
              placeItems: "center",
              background: `linear-gradient(135deg, ${palette.error.main} 0%, ${palette.info.main} 100%)`,
              color: palette.white.main,
              fontWeight: 800,
              fontSize: "1rem",
              flexShrink: 0,
            })}
          >
						<img
							style={{
								height: "100%",
								maxWidth: "100%",
								display: "block",
								margin: "auto",
								borderRadius : '100%'
							}}
							src={Logo}
						/>
          </MDBox>
          <MDBox width={!brandName && "100%"}>
            <MDTypography component="h6" variant="h6" fontWeight="bold" color={textColor}>
              {brandName}
            </MDTypography>
            <MDTypography variant="caption" sx={{ color: (theme) => theme.functions.rgba(theme.palette.white.main, 0.68) }}>
              Operations Hub
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider sx={(theme) => ({ borderColor: theme.functions.rgba(theme.palette.white.main, 0.08), mb: 1 })} />
      <List sx={{ px: 1.25 }}>{renderRoutes}</List>
      {/*{!miniSidenav && (*/}
        <MDBox sx={{ px: 2, pb: 2, mt: "auto", }}>
          <MDBox
            sx={({ palette, functions }) => ({
              p: 1.4,
              borderRadius: "16px",
              //backgroundColor: functions.rgba(palette.dark.focus, 0.5),
              border: `1px solid ${functions.rgba(palette.white.main, 0.08)}`,
              display: "flex",
              alignItems: "center",
              gap: 4,
            })}
          >
            <MDBox
              sx={({ palette }) => ({
                width: 40,
                height: 40,
                //borderRadius: "10%",
                //backgroundColor: palette.info.main,
                color: palette.white.main,
                display: "grid",
                placeItems: "center",
                fontWeight: 700,
                fontSize: "0.78rem",
              })}
            >
							<MDAvatar
								src={normalizeImage(employee?.img)}
								alt="employee-avatar"
								size="m"
								sx={{
									border: `1px solid ${colors.white.main}`,
									boxShadow: `0 8px 20px ${rgba(colors.dark.main, 0.12)}`,
								}}
							/>
            </MDBox>
            <MDBox sx={{ minWidth: 0 , display: "flex"}}>
							<MDBox>
              <MDTypography variant="button" sx={(theme) => ({ color: theme.palette.white.main, display: "block" })} noWrap>
                {employee?.user?.firstname
                  ? `${employee?.user?.firstname} ${employee?.user?.lastname || ""}`
                  : "Current User"}
              </MDTypography>
              <MDTypography variant="caption" sx={(theme) => ({ color: theme.functions.rgba(theme.palette.white.main, 0.62) })}>
								GE - {employee?.emp_id|| ""}
              </MDTypography>
							</MDBox>
							<MDBox>				
									<IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                 onClick={handleOpenUserMenu}
                >
                  <Icon  sx={{color : colors.light.focus}}>keyboard_arrow_up</Icon>
                </IconButton>	
									{renderUserMenuItems()}
							</MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      {/*)}*/}
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
